import React from "react";
import ReactDOM from "react-dom/client";
import { PublicClientApplication, EventType } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import { msalConfig } from "./context/msalConfig";
import App from "./App";
import { creditStepUpIfStarted } from "./context/AuthContext";
import "./theme/global.css";

const msalInstance = new PublicClientApplication(msalConfig);

msalInstance.initialize().then(async () => {
  const accounts = msalInstance.getAllAccounts();
  if (accounts.length > 0) msalInstance.setActiveAccount(accounts[0]);

  msalInstance.addEventCallback((event) => {
    if (event.eventType === EventType.LOGIN_SUCCESS && event.payload.account) {
      msalInstance.setActiveAccount(event.payload.account);
    }
  });

  // Process a returning redirect HERE, before rendering. A completed
  // step-up is then credited from plain storage before any component mounts,
  // instead of depending on an event listener being attached in time or on
  // the account's claims having updated -- the two things the first two
  // attempts at this relied on, and the loop that came of it.
  try {
    const result = await msalInstance.handleRedirectPromise();
    if (result?.account) {
      msalInstance.setActiveAccount(result.account);
      creditStepUpIfStarted();
    }
  } catch {
    // A failed redirect response leaves the admin signed out, which the
    // login screen already handles; there is nothing to credit.
  }

  ReactDOM.createRoot(document.getElementById("root")).render(
    <React.StrictMode>
      <MsalProvider instance={msalInstance}>
        <App />
      </MsalProvider>
    </React.StrictMode>
  );
});
